import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { CardContent, Typography, Card, Button, Grid } from '@material-ui/core'
import useRouter from 'utils/useRouter';
import { injectIntl } from 'react-intl';
import { ReactComponent as IconEmoji } from 'assets/svgs/emoji.svg';
import { loggedInSelector, } from 'redux/selectors';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
    card: {
        backgroundColor: 'white',
        borderRadius: 15
    },
    emojiIcon: {
        width: 60,
        height: 60,
        marginBottom: theme.spacing(1)
    },
    button: {
        textTransform: 'none',
        borderRadius: 100
    },
    emptyContent: {
        minHeight: "calc(100vh - 280px)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
    },
}));

function EmptyPage({ title, buttonLabel, onClick, reduced }) {
    const classes = useStyles();
    const router = useRouter();
    const isLoggedIn = useSelector(loggedInSelector);

    return (
        <Card className={classes.card}>
            <CardContent className={classes.emptyContent} style={reduced ? { minHeight: "auto" } : {}}>
                <br />
                <br />
                <IconEmoji className={classes.emojiIcon} />
                <Typography variant="h3"><strong>{title || "Vous n’avez aucun produit dans votre panier."}</strong></Typography>
                <Typography style={{ marginTop: 4 }}>Notre équipe reste a votre disposition si vous avez des questions.</Typography>
                <br />
                <br />
                <br />
                <Grid container justify='center'>
                    <Button variant='contained' color="primary" className={classes.button} style={{ backgroundColor: '#05A969' }}
                        onClick={onClick || (() => {
                            router.history.push(isLoggedIn ? "/catalogue" : "/invite")
                        })}
                    >{buttonLabel || "Découvrir nos produits"}</Button>
                </Grid>
                <br />
                <br />
            </CardContent>
        </Card>
    );
}
EmptyPage.propTypes = {
    title: PropTypes.string,
    buttonLabel: PropTypes.string,
    onClick: PropTypes.func,
    reduced: PropTypes.bool
};
export default injectIntl(EmptyPage)